import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// -------------------- Modal Confirmation Dialog Buttons --------------------
class Id {
  private constructor() {}

  public static readonly prefix = 'UI.webmodule-common.other.ui.ModalConfirmation.';
  public static readonly yes = `${Id.prefix}yes`;
  public static readonly no = `${Id.prefix}no`;
  public static readonly ok = `${Id.prefix}ok`;
  public static readonly cancel = `${Id.prefix}cancel`;
  public static readonly continue = `${Id.prefix}continue`;
  public static readonly saveAndClose = `${Id.prefix}saveAndClose`;
  public static readonly confirm = `${Id.prefix}confirm`;
}

export class LangModalConfirmation {
  private constructor() {}

  public static yes(): string {
    return interpolate(Id.yes);
  }

  public static no(): string {
    return interpolate(Id.no);
  }

  public static ok(): string {
    return interpolate(Id.ok);
  }

  public static cancel(): string {
    return interpolate(Id.cancel);
  }

  public static continue(): string {
    return interpolate(Id.continue);
  }

  public static saveAndClose(): string {
    return interpolate(Id.saveAndClose);
  }

  public static confirm(): string {
    return interpolate(Id.confirm);
  }
}

export class ModalConfirmationModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.yes, 'Yes', 'Confirmation button: Yes');
    register.add(Id.no, 'No', 'Confirmation button: No');
    register.add(Id.ok, 'Ok', 'Confirmation button: Ok');
    register.add(Id.cancel, 'Cancel', 'Confirmation button: Cancel');
    register.add(Id.continue, 'Continue', 'Confirmation button: Continue');
    register.add(Id.saveAndClose, 'Save & Close', 'Confirmation button: Save & Close');
    register.add(Id.confirm, 'Confirm', 'Button: confirm');
  }
}
